import React from 'react';
import { useAppState } from '../../hooks/useAppState';

/**
 * usage:
 * <div ref={parentRef} style={{maxWidth: 792}}>
 *  <PageStrut id={unique} parentRef={parentRef} />
 * </div>
 *
 * will make the page contents 1150px tall, assumes parent is 792 px (A4 or thereabouts)
 */
const PageStrut = ({
  id,
  parentRef,
  pageHeight = 1150,
}: {
  id: string | number;
  parentRef: any;
  pageHeight?: number;
}) => {
  // app state needed to retain height between rendering for react-to-pdf usage
  const [height, setHeight] = useAppState(`strut_${id}`, 0);

  React.useEffect(() => {
    if (parentRef.current && !height) {
      const parentHeight = parentRef.current.offsetHeight;
      if (parentHeight < pageHeight) {
        setHeight(pageHeight - parentHeight);
      }
    }
    // eslint-disable-next-line
  }, [parentRef.current]);
  if (!parentRef?.current && !height) {
    return null;
  }
  return <div style={{ height }}>&nbsp;</div>;
};

export default PageStrut;
